export enum EPriceType
{
    TwoKidsSeperateRoom = 12,
    FamilyRoom = 17,
    ThreeKidsSeperateRoom = 13,
    Deletmekasheret = 15
}